/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import URI from 'urijs'
import Environment from '../../models/environment.js'
import _ from 'underscore'

const env = new Environment()

/*
 * A collection a helper methods shared by the classes in this namespace.
 * We may want to consider converting this into a mixin, since these are
 * really just shared private methods.
 * @namespace Ajax.Csrf
 * @mixin
 */
var Util = {
  requiresCsrfToken (tokens, options) {
    return !/^(get|head|options)$/i.test(options.type) &&
      Util.domainExpectsCsrfToken(tokens, Util.hostFromUrl(options.url)) &&
      !options.firehose
  },

  hostFromUrl (url) {
    const base = (typeof location !== 'undefined' && location !== null) ? location.href + '' : ''
    return URI(url).absoluteTo(base).host()
  },

  /*
   * True if the given URL should have the X-CSRF-Token header set
   * False otherwise.
   */
  domainExpectsCsrfToken (tokens, host) {
    // Assume we expect a token if we have already received on for this host
    if (tokens[host]) { return true }
    /*
     * TODO: Sometimes environment is undefined. Figure out why and fix it.
     *       It seems to be related to calls to firehose.
     *       So far we've only seen this in the jasmine tests.
     */
    let whitelist = [env.get('api_url'), env.get('root_url'), URI(typeof window !== 'undefined' && window !== null ? window.location.href : undefined)]
    whitelist = _.compact(whitelist)
    whitelist = _.invoke(whitelist, 'host')

    return _.include(whitelist, host)
  }
}

export default Util
